import React from "react";
import { format } from "date-fns";
import CalendarIcon from "../../icons/calendarIcon";
import styles from "./style.module.css";

const ReportCard = ({ item }) => {
    return (
        <div className={styles.report_card}>
            <div className={styles.report_card_head}>
                <div className={styles.report_card_info}>
                    <div className={styles.report_card_info_date}>
                        <div className={styles.report_card_info_date_item}>
                            <CalendarIcon />
                            <span>{format(new Date(item.date.replace('Z', '')), "dd MMM yyyy")}</span>
                        </div>
                    </div>
                    <div className={styles.report_card_name}>{item?.consumable?.name}</div>
                </div>
            </div>
            <div className={styles.report_card_foot}>
                <div className={styles.report_card_foot_desc}>{item.description}</div>
                <div className={styles.report_card_foot_cost}>{item.cost ? `$${item.cost}` : ""}</div>
            </div>
        </div>
    );
};

export default ReportCard;
